import { Controller } from 'stimulus'
import throttle from '../utils/throttle'

export default class extends Controller {
  static targets = ['container']

  initialize() {
    this._handleKeyDown = this.handleKeyDown.bind(this)
    this._handleScroll = throttle(this.handleScroll.bind(this), 10)
  }

  toggleNav(_e, force = null) {
    if (force !== null) {
      this.containerTarget.classList.toggle('header--nav-open', force)
      document.body.classList.toggle('nav-open', force)
    } else {
      this.containerTarget.classList.toggle('header--nav-open')
      document.body.classList.toggle('nav-open')
    }

    this.containerTarget.classList.add('header--animating')
    setTimeout(() => this.containerTarget.classList.remove('header--animating'), 600)
  }

  handleKeyDown(event) {
    // Close on escape
    if (event.keyCode === 27) {
      this.toggleNav(event, false)
    }
  }

  handleScroll() {
    if (window.pageYOffset <= 100) {
      this.element.classList.add('header--at-top')
      this.element.classList.remove('header--not-top')
    } else {
      this.element.classList.add('header--not-top')
      this.element.classList.remove('header--at-top')
    }
  }

  connect() {
    document.addEventListener('keydown', this._handleKeyDown)
    window.addEventListener('scroll', this._handleScroll)
    this.handleScroll()

    // Ensure the menu is closed before Turbolinks preview caches the page so that visitors using the back button
    // don't see the menu when they go back.
    document.addEventListener(
      'turbolinks:before-cache',
      () => {
        this.containerTarget.classList.remove('header--nav-open')
        document.body.classList.remove('nav-open')
      },
      { once: true }
    )
  }

  disconnect() {
    document.removeEventListener('keydown', this._handleKeyDown)
  }
}
